/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdditiveDetailsDto } from './AdditiveDetailsDto';
import type { BaseOilDetailsDto } from './BaseOilDetailsDto';
import type { ContainerSizeDetailsDto } from './ContainerSizeDetailsDto';
import type { SalesAreaDetailsDto } from './SalesAreaDetailsDto';
export type ProductFormulationDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    productId: string;
    productTypeIdentifier: ProductFormulationDto.productTypeIdentifier;
    saeClassId?: string;
    saeClassName?: string;
    salesAreas?: Array<SalesAreaDetailsDto>;
    containerSizes?: Array<ContainerSizeDetailsDto>;
    additives?: Array<AdditiveDetailsDto>;
    baseOils?: Array<BaseOilDetailsDto>;
    formulationState: ProductFormulationDto.formulationState;
    formulation: string;
    sheetId: string;
    readonly sheetNumber?: string;
    readonly thirdPartyCertificateRequiredForSheet?: boolean;
    comment?: string;
    orderNumber?: string;
    manufacturerLocation?: string;
    readonly approvalReceivedAt?: string;
    validityBasedOn?: ProductFormulationDto.validityBasedOn;
    readonly approvalValidUntil?: string;
    /**
     * Calculated trigger date for renewal handling.
     */
    readonly renewalTriggerAt?: string;
    /**
     * Indicates if the formulation is currently in draft mode for renewal editing.
     */
    readonly draftMode?: boolean;
    readonly unlimitedApproval?: boolean;
    readonly sheetRequiresThirdPartyCertificate?: boolean;
    hasPrimaryProductThirdPartyCertificate?: boolean;
    thirdPartyCertificateValidUntil?: string;
    thirdPartyCertificateSpecificationNumber?: string;
    readonly active?: boolean;
};
export namespace ProductFormulationDto {
    export enum productTypeIdentifier {
        ORIGINAL = 'ORIGINAL',
        REBRAND = 'REBRAND',
        REBLEND = 'REBLEND',
        ALL = 'ALL',
    }
    export enum formulationState {
        NEW = 'NEW',
        REQUESTED = 'REQUESTED',
        APPROVED = 'APPROVED',
        CANCELLED = 'CANCELLED',
        REJECTED = 'REJECTED',
        EXPIRED = 'EXPIRED',
        INACTIVE = 'INACTIVE',
        ANNUAL_REPORT_DUE = 'ANNUAL_REPORT_DUE',
        ANNUAL_REPORT_NOT_EXTENDED = 'ANNUAL_REPORT_NOT_EXTENDED',
        ANNUAL_REPORT_OVERDUE = 'ANNUAL_REPORT_OVERDUE',
        RENEWAL_REQUIRED = 'RENEWAL_REQUIRED',
        RENEWAL_APPROVAL_REQUIRED = 'RENEWAL_APPROVAL_REQUIRED',
        RENEWAL_APPROVAL_REQUESTED = 'RENEWAL_APPROVAL_REQUESTED',
        REWORK_NECESSARY = 'REWORK_NECESSARY',
    }
    export enum validityBasedOn {
        SHEET = 'SHEET',
        THIRD_PARTY_CERTIFICATE = 'THIRD_PARTY_CERTIFICATE',
    }
}

